'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function PaymentComponent($http, AppConstants) {
	'ngInject';

	var service = {
		fetchPaymentButton: fetchPaymentButton,
		getPaymentButton: getPaymentButton
	};

	var paymentButton = {};

	return service;

	function fetchPaymentButton(ticketId, urls) {
		var params = {
			'params': {
				'ticket_id': ticketId,
				'url_ok': urls.url_ok,
				'url_cancel': urls.url_cancel
			}
		};

		return $http.get(AppConstants.apiUrl + '/payment-buttons', params).then(setPaymentButton)['catch'](failedRequest);
	}

	function setPaymentButton(response) {
		paymentButton = response.data.data;

		return paymentButton;
	}

	function getPaymentButton() {
		return paymentButton;
	}

	function failedRequest(requestError) {
		console.log(requestError);
		return requestError;
	}
}
exports['default'] = PaymentComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/payment/payment.service.js
 **/